<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
    </div>
    <div class="global-table-container">
      <basic-form
        ref="basicForm"
        :form-data="formData"
      >
        <template #type>
          <a-select
            v-decorator="[
              'type',
              { rules: [{ required: true, message: '请选择表单类型' }],
                initialValue: data.type },

            ]"
            :disabled="selectDisabled"
            placeholder="请选择表单类型"
          >
            <a-select-option
              v-for="(item,index) in typeData"
              :key="index"
              :value="index"
            >
              {{ item }}
            </a-select-option>
          </a-select>
        </template>
        <template #service_id>
          <a-select
            v-decorator="[
              'service_id',
              { rules: [{ required: true, message: '请选择服务活动' }],
                initialValue: data.service_id },
            ]"
            :disabled="disabled"
            placeholder="请选择服务活动"
          >
            <a-select-option
              v-for="item in activityData"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </template>
        <template #label>
          <a-input
            v-decorator="[
              'label',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入表单名称',
                  },
                ],
                initialValue: data.label
              },
            ]"
            :disabled="disabled"
            placeholder="请输入表单名称"
          />
        </template>
        <template #hint>
          <a-input
            v-decorator="[
              'hint',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入表单输入提示',
                  },
                ],
                initialValue: data.hint
              },
            ]"
            :disabled="disabled"
            placeholder="请输入表单输入提示"
          />
        </template>
        <template #help_tips>
          <a-input
            v-decorator="[
              'help_tips',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入校验提示语',
                  },
                ],
                initialValue: data.help_tips
              },
            ]"
            :disabled="disabled"
            placeholder="请输入校验提示语"
          />
        </template>
        <template #area_index>
          <a-input
            v-decorator="[
              'area_index',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入分区序号',
                  },
                ],
                initialValue: data.area_index
              },
            ]"
            :disabled="disabled"
            placeholder="请输入分区序号"
          />
        </template>
        <template #edit_flag>
          <a-radio-group
            v-decorator="['edit_flag',{rules:[{
                                         required: true,
                                         message: '请选择是否可编辑',
                                       },],
                                       initialValue: data.edit_flag
            }]"
            :disabled="disabled"
          >
            <a-radio value="1">
              可以
            </a-radio>
            <a-radio value="0">
              不可以
            </a-radio>
          </a-radio-group>
        </template>
        <template #list_show_flag>
          <a-select
            v-decorator="[
              'list_show_flag',
              { rules: [{ required: true, message: '请选择是否显示' }],
                initialValue: data.list_show_flag },
            ]"
            placeholder="请选择是否显示"
          >
            <a-select-option
              v-for="item in showData"
              :key="item.key"
              :value="item.key"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </template>
        <template #config_view>
          <a-textarea
            v-decorator="[
              'config_view',
              { rules: [{ required: false, }],
                initialValue: data.config_view },
            ]"
            :disabled="disabled"
            rows="6"
            placeholder="请输入"
            maxlength="150"
          />
        </template>
        <template #config_data>
          <a-textarea
            v-decorator="[
              'config_data',
              { rules: [{ required: false, }],
                initialValue: data.config_data },
            ]"
            :disabled="disabled"
            rows="6"
            placeholder="请输入"
            maxlength="150"
          />
        </template>
        <template #sort>
          <a-input-number
            v-decorator="[
              'sort',
              { rules: [{ required: true, message: '请输入排序' }],
                initialValue: data.sort },
            ]"
            :disabled="disabled"
          />
        </template>
      </basic-form>
      <div style="text-align:right">
        <a-button @click="onCancel">
          返回
        </a-button>
        <a-button
          :btn-is-loading="btnIsLoading"
          :disabled="disabled"
          type="primary"
          style="margin-left:20px;"
          @click="handleSubmit"
        >
          提交
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
const uuidv1 = require('uuid/v1');
import {formData} from './../data/index';
export default {
  data(){
    return{
      btnIsLoading: false,
      formData,
      typeData: ['输入框', '下拉单选', '单图上传', '多图上传', '地图定位', '日期时间选择', '特殊下拉框', '下拉多选', '数据检索'],
      activityData: [
      ],
      disabled: false,
      selectDisabled: false,
      id: '',
      data: {},
      showData: [],
    };
  },
  mounted(){
    // 获取服务活动
    this.getActivity();
    this.getShowData();
    // 查看
    if(this.$route.query&&this.$route.query.disabled==='true'){
      this.disabled=true;
      this.selectDisabled=true;
    }
    // 编辑
    if(this.$route.query&&this.$route.query.id){
      let id=this.$route.query.id;
      this.selectDisabled=true;
      this.getDetails(id);
    }
  },
  methods: {
    // 回显
    async getDetails(id){
      let result = await this.$http.post(
        '/ServiceForm/info',
        {id},
      );
      if (result.data.status === 1) {
        let res=result.data.data;
        console.log('TCL: getDetails -> res', res);
        this.data={
          type: res.type,
          service_id: res.service_id,
          label: res.label,
          area_index: res.area_index,
          hint: res.hint,
          help_tips: res.help_tips,
          edit_flag: String(res.edit_flag),
          list_show_flag: String(res.list_show_flag),
          config_view: res.config_view,
          config_data: res.config_data,
          sort: res.sort,
        };
      }
    },
    // 获取服务活动
    async getActivity() {
      this.loading = true;
      let result = await this.$http.post(
        '/Service/getList',
        {page: 0, pageSize: 0},
      );
      if (result.data.status === 1) {
        this.activityData = result.data.data.data_list;
      }
    },
    // 获取是否显示数据
    async getShowData() {
      let result = await this.$http.post(
        '/system/getConfigs',
      );
      if (result.data.status === 1) {
        this.showData = result.data.data.service_form_item_showflag;
        console.log('getShowData -> this.showData', this.showData);
      }
    },
    //
    handleSubmit() {
      this.$refs.basicForm.form.validateFields(async(err, values) => {
        console.log('TCL: handleSubmit -> values', values);
        if (!err) {
          this.btnIsLoading=true;
          if(this.$route.query&&this.$route.query.disabled==='false'){
            this.id=this.$route.query.id;
          }
          let data={
            id: this.id?this.id:undefined,
            type: values.type,
            service_id: values.service_id,
            label: values.label,
            area_index: values.area_index,
            hint: values.hint,
            help_tips: values.help_tips,
            edit_flag: String(values.edit_flag),
            list_show_flag: String(values.list_show_flag),
            config_view: values.config_view,
            config_data: values.config_data,
            sort: values.sort,
          };
          let result = await this.$http.post(
            '/ServiceForm/update',
            data,
          );
          this.btnIsLoading=false;
          if (result.data.status === 1) {
            this.$message.success('操作成功！');

            this.$router.back();
          }
        }
      });
    },
    // 返回
    onCancel(){
      this.$router.back();
    },
  },
};
</script>

<style>

</style>